import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add Organisation
export const addOrganisation = async (formData) => {
  console.log("Organisation form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}organisation/api/v1/create-organisation`, formData, {
    //   headers: {
    //     "auth-token": token,
    //   }
    headers: { "Content-Type": "multipart/form-data" }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// delete Organisation  API
export const deleteOrganisation = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}organisation/api/v1/delete-organisation/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// update Organisations
export const updateOrganisation = async (ROWID, data) => {
  console.log({ data })
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}organisation/api/v1/update-organisation/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// total count
export const countOrganisation = async (formData) => {
  console.log(formData,"count")
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}organisation/api/v1/get-organisation-count`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const getOrganisationDetailById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}organisation/api/v1/get-organisation-by-id/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}
